/**
 * PasswordGate: záložní ochrana appky, když není nastavené Supabase přihlášení.
 * Heslo se bere jen z env var REACT_APP_ACCESS_PASSWORD. Bez ní brána nikoho
 * nepustí (dřív tu bylo natvrdo výchozí heslo přímo v balíčku, viz test. etapa).
 */
import React, { useState } from 'react';

const ACCESS_PASSWORD = process.env.REACT_APP_ACCESS_PASSWORD || null;
const STORAGE_KEY = 'valuator_authenticated';

export function PasswordGate({ children }) {
  const [authenticated, setAuthenticated] = useState(
    () => sessionStorage.getItem(STORAGE_KEY) === 'true'
  );
  const [password, setPassword] = useState('');
  const [error, setError] = useState(false);

  if (authenticated) return children;

  const handleSubmit = (e) => {
    e.preventDefault();
    if (ACCESS_PASSWORD && password === ACCESS_PASSWORD) {
      sessionStorage.setItem(STORAGE_KEY, 'true');
      setAuthenticated(true);
    } else {
      setError(true);
      setPassword('');
    }
  };

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: '#0D0B1A',
      padding: '1rem',
    }}>
      {/* Subtle nebula glow */}
      <div style={{
        position: 'fixed',
        top: '30%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: '600px',
        height: '600px',
        borderRadius: '50%',
        background: 'radial-gradient(circle, rgba(107,63,160,0.15) 0%, transparent 70%)',
        pointerEvents: 'none',
      }} />

      <form onSubmit={handleSubmit} style={{
        background: '#120F24',
        border: '1px solid rgba(155, 89, 212, 0.15)',
        borderRadius: 16,
        padding: '3rem 2.5rem',
        boxShadow: '0 8px 40px rgba(0, 0, 0, 0.4)',
        maxWidth: 420,
        width: '100%',
        textAlign: 'center',
        position: 'relative',
        zIndex: 1,
      }}>
        {/* Lock icon */}
        <div style={{
          width: 56,
          height: 56,
          borderRadius: '50%',
          background: 'linear-gradient(135deg, #6B3FA0, #E040C8 150%)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          margin: '0 auto 1.25rem',
          boxShadow: '0 0 30px rgba(107, 63, 160, 0.4)',
        }}>
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <rect x="3" y="11" width="18" height="11" rx="2" ry="2"/>
            <path d="M7 11V7a5 5 0 0110 0v4"/>
          </svg>
        </div>

        <h2 style={{
          margin: '0 0 0.35rem',
          fontSize: '1.5rem',
          color: '#F4F0FF',
          fontFamily: "'Source Serif 4', Georgia, serif",
          fontWeight: 400,
          letterSpacing: '0.02em',
        }}>
          Valuace <em style={{ color: '#C89EF5' }}>podniku</em>
        </h2>
        <p style={{
          color: 'rgba(210, 195, 255, 0.6)',
          fontSize: '0.88rem',
          marginBottom: '2rem',
          fontFamily: "'Inter', sans-serif",
        }}>
          Zadejte přístupové heslo pro pokračování.
        </p>

        <input
          type="password"
          value={password}
          onChange={e => { setPassword(e.target.value); setError(false); }}
          placeholder="Heslo"
          autoFocus
          style={{
            width: '100%',
            padding: '0.85rem 1rem',
            border: `1px solid ${error ? 'rgba(239,68,68,0.5)' : 'rgba(155,89,212,0.25)'}`,
            borderRadius: 10,
            fontSize: '1rem',
            outline: 'none',
            boxSizing: 'border-box',
            marginBottom: '0.75rem',
            background: 'rgba(13, 11, 26, 0.6)',
            color: '#F4F0FF',
            fontFamily: "'Inter', sans-serif",
            transition: 'border-color 0.3s ease, box-shadow 0.3s ease',
          }}
          onFocus={e => {
            if (!error) {
              e.target.style.borderColor = '#9B59D4';
              e.target.style.boxShadow = '0 0 0 3px rgba(155,89,212,0.15), 0 0 20px rgba(107,63,160,0.1)';
            }
          }}
          onBlur={e => {
            e.target.style.borderColor = error ? 'rgba(239,68,68,0.5)' : 'rgba(155,89,212,0.25)';
            e.target.style.boxShadow = 'none';
          }}
        />

        {error && (
          <div style={{
            color: '#fca5a5',
            fontSize: '0.84rem',
            marginBottom: '0.5rem',
            fontFamily: "'Inter', sans-serif",
          }}>
            Nesprávné heslo. Zkuste to znovu.
          </div>
        )}

        <button
          type="submit"
          style={{
            width: '100%',
            padding: '0.85rem',
            background: 'linear-gradient(135deg, #6B3FA0, #E040C8 150%)',
            color: 'white',
            border: 'none',
            borderRadius: 10,
            fontSize: '0.85rem',
            fontWeight: 600,
            cursor: 'pointer',
            marginTop: '0.5rem',
            fontFamily: "'Inter', sans-serif",
            letterSpacing: '0.1em',
            textTransform: 'uppercase',
            boxShadow: '0 0 25px rgba(107, 63, 160, 0.35)',
            transition: 'all 0.3s ease',
          }}
          onMouseOver={e => {
            e.target.style.boxShadow = '0 0 45px rgba(107, 63, 160, 0.6)';
            e.target.style.transform = 'translateY(-1px)';
          }}
          onMouseOut={e => {
            e.target.style.boxShadow = '0 0 25px rgba(107, 63, 160, 0.35)';
            e.target.style.transform = 'translateY(0)';
          }}
        >
          Vstoupit
        </button>

        <p style={{
          marginTop: '1.5rem',
          fontSize: '0.72rem',
          color: 'rgba(210, 195, 255, 0.3)',
          fontFamily: "'Inter', sans-serif",
          letterSpacing: '0.15em',
          textTransform: 'uppercase',
        }}>
          M&Ai, Valuace e-commerce
        </p>
      </form>
    </div>
  );
}
